import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getShortLinkAction } from "../../redux/store/shortlink/actions";
import './../../assets/styles/loaders/loader.scss'

export default function Redirect() {
    const { shortlink } = useParams();
    const dispatch = useDispatch();
  
    useEffect(() => {
      if (shortlink) {
        dispatch(getShortLinkAction(shortlink)).then(res=>{
          console.log(res)
            if(res && res?._id){
                window.location.href = res.redirectLink
            }
        })
      }
    }, [shortlink,dispatch]);

    console.log(shortlink);
  return (
    <div
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          height: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <span className="loader"></span>
        {/* {text && <p style={{ fontSize: '20px', fontWeight: 700, marginTop: '10px' }}>{text}</p>} */}
         <p style={{ fontSize: '20px', fontWeight: 700, marginTop: '10px' }}>Please Wait </p>
      </div>
  );
}
